import router from './router'
import store from './store'

router.beforeEach((to, from, next) => {
  console.log('to:' + to.path)
  if (to.path.startsWith('/login')) {
    //window.localStorage.removeItem('access-user')
    sessionStorage.removeItem('userName');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('expiresIn');
    next()
  } else {
    let accessToken = sessionStorage.getItem('accessToken');
    if (!accessToken) {
      next({path: '/login'})
    } else {
      console.log('hasPermission:' + sessionStorage.getItem('roles'))
      if(hasPermission(sessionStorage.getItem('roles'),to.meta.roles)){
        console.log('hasPermission:' + sessionStorage.getItem('roles'))
        let roles = sessionStorage.getItem('roles');
        //添加动态路由
        store.dispatch('GenerateRoutes', { roles }).then(() => { // 生成可访问的路由表
          router.options.routes = store.getters.routes;
          router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
          next({ ...to, replace: true })
        })
        next()
      }
      else{
        next({ path: '/404', replace: true, query: { noGoBack: true }})
      }
    }
  }
})

function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0){
    return true // admin permission passed directly
  }
  if (!permissionRoles){
    return true
  }
  if(permissionRoles.indexOf(roles) >= 0){
    return true
  } 
  else{
    return false
  }
}



// WEBPACK FOOTER //
// ./src/permission.js